// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export class DnaSyngoviaColumnModel {
  public i18nLabelPrefix = 'syngovia.label';
  public property = '';
  public columnSize = '6';
  public columnType: 'string' | 'date' = 'string';
  public minWidth = '170px';
  public header: string | undefined = undefined;

  public constructor(defintion: Partial<DnaSyngoviaColumnModel>) {
    Object.assign(this, defintion);
  }

  get label(): string {
    return `${this.i18nLabelPrefix}.${this.header ?? this.property}`;
  }
}
